import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { AssetClassOverviewFacade } from '@zero/asset-class-overview/domain';
import { MostActiveAssetsComponent } from '@zero/asset-class-overview/feature-shared/web';
import { NotificationComponent } from '@zero/shared/ui-web-design-system';
import { InstrumentType } from '@zero/shared/util-models';
import { TradeTickerByInstrumentTypeComponent } from '@zero/statistics/feature-statistics/web';
import { DiscoverNewsComponent } from '../../components/discover-news/discover-news.component';
import { FamousStocksComponent } from '../../components/famous-stocks/famous-stocks.component';

@Component({
  selector: 'stocks-overview',
  imports: [
    TradeTickerByInstrumentTypeComponent,
    FamousStocksComponent,
    AsyncPipe,
    TranslocoPipe,
    NotificationComponent,
    NgTemplateOutlet,
    MostActiveAssetsComponent,
    DiscoverNewsComponent,
  ],
  templateUrl: './stock-overview.component.html',
})
export class StockOverviewComponent implements OnInit {
  public readonly facade: AssetClassOverviewFacade = inject(AssetClassOverviewFacade);
  public readonly instrumentType = InstrumentType.Share;
  public readonly notificationCacheKey = 'stocks-overview';

  public isDismissedNotification = false;

  ngOnInit(): void {
    this.facade.loadCustomerBaseData();
    this.isDismissedNotification = (JSON.parse(localStorage.getItem('dismissed-notifications')) || []).includes(this.notificationCacheKey);
  }
}
